import smotri from './smotri';
import chuma from './chuma';
import november from './november';
import fire_and_ice from './fire_and_ice';
import lem_trurl_i_schaste from './lem_trurl_i_schaste.js';

const list = [
	smotri,
	chuma,
	november,
	fire_and_ice,
	lem_trurl_i_schaste
];

export default list;